<template>
  <div style="height: 100%; width: 100%; position: relative">
    <LkLeftPanelBit />

    
    <div id="lk_right_panel_points"></div>
  </div>
</template>
<script>
import LkLeftPanelBit from '../components/LkLeftPanelBit'
import {useMyStorage} from "@/store/global";
import { ref} from 'vue'

export default {
  middleware: "auth",
  components:{
    LkLeftPanelBit,
    
  },
  name:"BitPage",
  setup(){
    const store=useMyStorage()
    const res=ref(store.dr) 
  const show=()=>{
    store.dataResponse.value=!store.dataResponse.value;
  }

    return{
      store,
      show,
      res
    }
  },
  methods: {
   
  },
};
</script>
<style>
@media (max-width: 1770px){
  #lk_right_panel_points {
    display: none !important;
  }
}
#lk_right_panel_points {
  position: absolute;
  right: 23px;
  top: 23px;
  width: 159px;
  height: 100%;
  overflow: hidden;
  background-image: url("data:image/svg+xml;utf8,<svg width='159' height='26' viewBox='0 0 159 26' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='53.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='79.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='1.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='105.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='27.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='131.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='157.5' cy='1.5' r='1.5' fill='%23E0E0E0'/></svg>");
  background-repeat: repeat-y;
  margin-bottom: -23px;
}

.small_top {
  margin-left: 3px;
  font-family: Proxima Nova Condensed;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 12px;
  color: #777777;
  position: absolute;
  display: inline-block;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>